import React, { useEffect } from "react";
import "../carousel/Carousel.css";
// import EventCard from "./EventCard";
import { useInView } from "react-intersection-observer";
import { useAnimation, motion } from "framer-motion";

export const EventCard = ({
  title,
  image,
  time,
  width,
  height,
  text,
  padding,
  rgb1,
  right,
}) => {
  return (
    <motion.div
      whileHover={{
        backgroundImage: `linear-gradient(
    rgb(${rgb1}),
    rgb(0, 15, 10, 0.8)
  ), url(${image})`,
        transition: {
          duration: "0.2",
          ease: "easeIn",
        },
      }}
      className={` flex justify-center items-center relative border-8 border-white p-${
        padding ? padding : "3"
      } cursor-pointer event__card`}
      style={{
        backgroundImage: `linear-gradient(
    rgb(0, 0, 2, 0.3),
    rgb(0, 15, 10, 0.4)
  ), url(${image})`,
        height: `${height}`,
        width: `${width ? width : "320px"}`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
      }}
    >
      <h1 className={`text-gray-200 text-${text ? text : "xl"} font-serif `}>
        {title}
      </h1>
      <p
        className={`absolute ${
          right ? "right-0" : "left-0"
        }  bottom-0 text-xs font-semibold bg-yellow-400 p-2`}
      >
        {time}
      </p>
    </motion.div>
  );
};

const Event = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  const animation = useAnimation();

  const variants = {
    visible: { opacity: 1, scale: 1, x: 0 },
    hidden: {
      opacity: 0,
      scale: 0.65,
      x: "100vw",
    },
  };

  useEffect(() => {
    if (inView) {
      animation.start({
        y: 0,
        opacity: 1,
        // transition: {
        //   type: "spring",
        //   duration: 1,
        //   bounce: 0.3,
        // },
      });
    }
    if (!inView) {
      animation.start({
        y: 70,
        opacity: 0,
      });
    }
  }, [inView, animation]);

  return (
    <div ref={ref} className="py-6 p-1 bg-white overflow-hidden">
      <div className="">
        <h1 className="text-center text-4xl font-serif">Events & News</h1>
      </div>
      {/** DEsktop */}
      <div className="hidden md:inline-flex flex-wrap md:flex-nowrap py-10 mt-8 overflow-hidden">
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants}
          transition={{ duration: 1.4, ease: "easeOut" }}
          className="z-0 "
          // style={{ width: "450px" }}
        >
          <EventCard
            rgb1="23,67,88,0.5"
            padding="10"
            text="2xl"
            height="450px"
            width="100%"
            title="How Our Student Has Been Working Hard on Their Assignment for Their Final Exam- 2021"
            image="https://images.pexels.com/photos/9433170/pexels-photo-9433170.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            time="14th Sep 2021"
          />
        </motion.div>
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants}
          transition={{ duration: 1.6, ease: "easeOut" }}
          className="z-10 md:-ml-14 md:mt-20"
        >
          <EventCard
            rgb1="200, 0, 0, 0.5"
            height="280px"
            width="280px"
            padding="4"
            title="Independence Day Celebration and How It Has Been Celebrated"
            image="https://images.pexels.com/photos/7551751/pexels-photo-7551751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            time="14th Sep 2021"
          />
        </motion.div>
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants}
          transition={{ duration: 1.8, ease: "easeOut" }}
          className="z-40 md:-ml-8 md:mt-6"
        >
          <EventCard
            rgb1="0, 140, 0, 0.5"
            height="280px"
            width="280px"
            title="Established Day 2019"
            image="https://images.pexels.com/photos/7647990/pexels-photo-7647990.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            time="14th Sep 2021"
          />
        </motion.div>
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants}
          transition={{ duration: 2.1, ease: "easeOut" }}
          className="z-0 md:-ml-12 md:mt-24"
        >
          <EventCard
            rgb1="233, 212, 96, 0.7"
            height="330px"
            width="330px"
            title="Established Day 2019"
            image="https://images.pexels.com/photos/9433170/pexels-photo-9433170.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            time="14th Sep 2021"
          />
        </motion.div>
        <motion.div
          animate={inView ? "visible" : "hidden"}
          variants={variants}
          transition={{ duration: 2.3, ease: "easeOut" }}
          className="z-40 md:-ml-12 md:mt-14"
        >
          <EventCard
            rgb1="0,0, 160, 0.5"
            height="220px"
            width="220px"
            title="Established Day 2019"
            image="https://images.pexels.com/photos/9433170/pexels-photo-9433170.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            time="14th Sep 2021"
          />
        </motion.div>
      </div>
      {/** Mobile */}
      <div className="md:hidden mt-8">
        <motion.div
          ref={ref}
          animate={inView ? "visible" : "hidden"}
          variants={variants}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <EventCard
            right
            rgb1="23,67,88,0.5"
            padding="10"
            text="2xl"
            height="450px"
            width="100%"
            title="How Our Student Has Been Working Hard on Their Assignment for Their Final Exam- 2021"
            image="https://images.pexels.com/photos/9433170/pexels-photo-9433170.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
            time="14th Sep 2021"
          />
        </motion.div>
        <div className="grid grid-cols-2">
          <motion.div
            ref={ref}
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 1.3, ease: "easeOut" }}
          >
            <EventCard
              right
              rgb1="23,67,88,0.5"
              text="base"
              height="200px"
              width="200px"
              title="Independence Day Celebration and How It Has Been Celebrated"
              image="https://images.pexels.com/photos/7551751/pexels-photo-7551751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              time="14th Sep 2021"
            />
          </motion.div>
          <motion.div
            ref={ref}
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 1.5, ease: "easeOut" }}
          >
            <EventCard
              right
              rgb1="23,67,88,0.5"
              text="base"
              height="200px"
              width="200px"
              title="Established Day 2019"
              image="https://images.pexels.com/photos/7647990/pexels-photo-7647990.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
              time="14th Sep 2021"
            />
          </motion.div>
          <motion.div
            ref={ref}
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 1.7, ease: "easeOut" }}
          >
            <EventCard
              right
              rgb1="23,67,88,0.5"
              text="base"
              height="200px"
              width="200px"
              title="Established Day 2019"
              image="https://images.pexels.com/photos/9433170/pexels-photo-9433170.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
              time="14th Sep 2021"
            />
          </motion.div>
          <motion.div
            ref={ref}
            animate={inView ? "visible" : "hidden"}
            variants={variants}
            transition={{ duration: 1.9, ease: "easeOut" }}
          >
            <EventCard
              right
              rgb1="23,67,88,0.5"
              text="base"
              height="200px"
              width="200px"
              title="Established Day 2019"
              image="https://images.pexels.com/photos/9433170/pexels-photo-9433170.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
              time="14th Sep 2021"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Event;
